import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useParams } from 'react-router-dom';

const Events = () => {
  const { groupId } = useParams();

  return (
    <Box>
      <Typography variant="h4" gutterBottom fontWeight={600}>
        Events
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Events for Group ID: {groupId}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          Coming soon...
        </Typography>
      </Paper>
    </Box>
  );
};

export default Events;